import { Gym } from 'fitbeat.models';
import React from 'react';
import { connect } from 'react-redux';
import { IAppStore } from '../../rootReducer';
import Dropdown from '../../shared/components/Dropdown';
import { currentGymSelector } from '../../adminSettings/selector';
import { getEmailToSMSDomain } from '../../util/helpers';

interface IPartialMemberDetailsForThisComponentOnly {
  Email: string;
  Name: string;
  UID: string;
  'Mobile Number'?: string;
}

interface IProps {
  currentGym: Gym;
  exportData?: IPartialMemberDetailsForThisComponentOnly[];
  toggleGeneralNotificationsModal(): void;
}

interface IState {
  showCopiedFor: string | null;
}

class MessageActionsDropdown extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      showCopiedFor: null,
    };
  }

  public createActionList = () => {
    const emails = {
      optionMethod: () => this.copyEmailsAction(),
      optionText: 'Copy Emails',
      tooltip: 'This contains names and emails. Paste in email sender into bcc in e.g. Gmail.',
    };
    const sms = {
      optionMethod: () => this.copySmsAction(),
      optionText: 'Copy Email to SMS',
      tooltip:
        'Contains Email to SMS list to paste in your email sender. '
        + 'A supported EmailToSMS service should be enabled, e.g Textmagic',
    };
    const generalNotification = {
      optionMethod: () => this.props.toggleGeneralNotificationsModal(),
      optionText: 'Send App Notifications',
      tooltip: 'People who enabled notifications in their app will receive immediately',
    };
    return [generalNotification, emails, sms];
  };

  public render() {
    return (
      <div className='dropdown-tooltip-wrapper'>
        <span className='dropdown-tooltip-text'>
          {`Selected user count: ${this.props.exportData?.length}`}
        </span>
        <Dropdown
          options={this.createActionList()}
          value={{ value: 'Send Message to Filtered', label: 'Send Message to Filtered' }}
          placeholder='Send Message to Filtered'
          className='message-action-select-container'
          classNamePrefix='message-action-select'
          isSearchable={false}
          components={{ Option: this.customOption }}
        />
      </div>
    );
  }

  private copySmsAction = () => {
    const toBeCoppiedUserList: string[] = [];
    this.props.exportData?.forEach((singleMemberDetails: IPartialMemberDetailsForThisComponentOnly) => {
      const emailToSMSDomain = getEmailToSMSDomain(this.props.currentGym);
      toBeCoppiedUserList.push(
        `${singleMemberDetails.Name} <${singleMemberDetails['Mobile Number']}@${emailToSMSDomain}>`,
      );
    });
    this.copyAction(toBeCoppiedUserList, 'sms');
  };

  private copyEmailsAction = () => {
    const toBeCoppiedUserList: string[] = [];
    this.props.exportData?.forEach((singleMemberDetails: IPartialMemberDetailsForThisComponentOnly) => {
      toBeCoppiedUserList.push(`${singleMemberDetails.Name} <${singleMemberDetails.Email}>`);
    });
    this.copyAction(toBeCoppiedUserList, 'emails');
  };

  private copyAction = (toBeCoppiedUserList: string[], key: string) => {
    const mappedDataAsString = toBeCoppiedUserList.join(',');
    // todo: try to use TextCopyToClipBoard, or extract helper
    navigator.clipboard.writeText(mappedDataAsString)
      .catch((e) => { /* no-op, this should show/log error */});

    this.setState({ showCopiedFor: key });

    setTimeout(() => {
      this.setState({ showCopiedFor: null });
    }, 1000);
  };

  private customOption = (optionProps: any) => {
    const HandleOptionClick = () => {
      optionProps.selectOption(optionProps.data.optionText);
      optionProps.data.optionMethod();
    };
    return (
      <div
        {...optionProps.data.innerProps}
        className={`row jr-btn-no-border message-action-dropdown-option
          ${optionProps.data.optionContainerCustomStyleClass}`}
        onClick={HandleOptionClick}
      >
        {optionProps.data.optionIcon}
        <div className='message-action-option-text'>{optionProps.data.optionText}</div>
        {
          optionProps.data.tooltip && (
            <div className='tooltip-wrapper'>
              <span className='tooltip-text'>
                {optionProps.data.tooltip}
              </span>
            </div>
          )
        }
      </div>
    );
  };
}

const mapStateToProps = (state: IAppStore) => {
  const { adminSettings } = state;
  const { exportData } = adminSettings.data;
  const currentGym = currentGymSelector(state);
  return { exportData, currentGym };
};

export default connect(mapStateToProps, null)(MessageActionsDropdown);
